import Mention from '@tiptap/extension-mention';
import { ReactRenderer } from '@tiptap/react';

import { MentionList } from 'dashboard/components-lib/RichTextEditor/Mentions/MentionList';
import { userDisplayName } from 'dashboard/lib/valueDisplayers/userDisplayName';
import { User, UserResponseAttributes, UserStatus } from 'dashboard/models/user';

interface MentionProps {
  users: User[];
}
const MentionExtension = ({ users }: MentionProps) => {
  return Mention.configure({
    HTMLAttributes: {
      class: 'mention',
    },
    suggestion: {
      items: ({ query }: { query: string }) => {
        return (
          users
            .filter((user: User) => user.attributes.status === UserStatus.Active)
            .map((user: User) => {
              return {
                displayName: userDisplayName(user),
                availability: user.attributes.availability,
                profilePictureUrl: (user.attributes as UserResponseAttributes)[
                  'profile-picture-url'
                ],
                userId: user.id,
              };
            })
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            .filter((item) => item.displayName.toLowerCase().startsWith(query.toLowerCase()))
            .slice(0, 5)
        );
      },

      render: () => {
        let component: ReactRenderer;

        return {
          onStart: (props: React.ComponentProps<typeof MentionList>) => {
            component = new ReactRenderer(MentionList, {
              props,
              editor: props.editor,
            });
          },

          onUpdate(props: React.ComponentProps<typeof MentionList>) {
            component.updateProps(props);

            if (!props.clientRect) {
              return;
            }
          },

          onKeyDown(props: React.ComponentProps<typeof MentionList>) {
            /* @ts-expect-error FIX ME: remove this ts-expect-error and fix typing on event  */
            if ((props.event as KeyboardEvent).key === 'Escape') {
              return true;
            }

            /* @ts-expect-error FIX ME: remove this ts-expect-error and fix typing on ref  */
            return component.ref?.onKeyDown(props);
          },

          onExit() {
            component?.destroy();
          },
        };
      },
    },
  });
};

export default MentionExtension;
